import { defineStore } from 'pinia';

export const useMainStore = defineStore('mainStore', {
    // State: Reactive properties of the store
    state: () => ({
        userData: null,
        userInternetData: null,
        userTvData: null,

        profileForDeletion: null,
        profileForDeletionAddress: null,

        currentTariffType: null,
        currentTariffObject: null,
        currentTariffPeriod: null,

        currentNotifications: null,
        currentNotificationsEng: null,

        additionalServicesCheck: null
    }),

    // Getters: Computed properties for the store
    getters: {
        address_formatted: (state) => state.userData?.address_formatted,
        login: (state) => state.userData?.login,
        payed_period: (state) => state.userInternetData?.payed_period.date_end,
        tv_payed_period: (state) => state.userTvData?.payed_period.date_end,
        internet_tariff: (state) => state.userInternetData?.selected_tariff,
        tv_tariff: (state) => state.userTvData?.selected_tariff,
        payments: (state) => state.userData?.payments,
        profile_for_deletion: (state) => state.profileForDeletion,
        profile_for_deletion_address: (state) => state.profileForDeletionAddress,
        autoWriteOffInternet: (state) => state.userData?.autospis,
        autoWriteOffTv: (state) => state.userData?.autospis_tv,
        tariffType: (state) => state.currentTariffType,
        tariffObject: (state) => state.currentTariffObject,
        tariffPeriod: (state) => state.currentTariffPeriod,
        balance: (state) => +state.userData?.balance,
        notifications: (state) => state.currentNotifications,
        notificationsEng: (state) => state.currentNotificationsEng,
        user_id: (state) => state.userData?.uid,

        autowriteoff: (state) => state.userData?.autospis,
        autowriteoff_tv: (state) => state.userData?.autospis_tv,
        special_tariffs_available: (state) => state.userData?.special_tariffs_available,

        cardNum: (state) => state.userData?.card_num,

        additional_services: (state) => state.additionalServicesCheck,
    },

    // Actions: Methods to modify the state
    actions: {
        setUserData(userData) {
            this.userData = userData
        },
        setUserInternetData(userInternetData) {
            this.userInternetData = userInternetData
        },
        setUserTvData(userTvData) {
            this.userTvData = userTvData
        },
        setProfileForDeletion(profile) {
            this.profileForDeletion = profile
        },
        setProfileForDeletionAddress(address) {
            this.profileForDeletionAddress = address
        },
        setCurrentTariffType(tariffType) {
            this.currentTariffType = tariffType
        },
        setTariffObject(tariffObject) {
            this.currentTariffObject = tariffObject
        },
        setCurrentTariffPeriod(tariffPeriod) {
            this.currentTariffPeriod = tariffPeriod
        },
        setCurrentNotifications(notifications) {
            this.currentNotifications = notifications
        },
        setCurrentNotificationsEng(notifications) {
            this.currentNotificationsEng = notifications
        },
        setAdditionalServicesCheck(services) {
            this.additionalServicesCheck = services
        }
    },
});
